<template>
    <div class="vm-feed-add-btn">
        <div class="inner-box">
            <i class="afd afd-plus"></i>
        </div>
    </div>
</template>
<script>
// import { mapState } from 'vuex';
export default {
    name: 'feedAddBtn',
    props: {
        data: {
            type: Object,
            default(){
                return {}
            }
        }
    },
    data() {
        return {
            is_show_more:false,
        };
    },
    computed:{
        // ...mapState('app', ['session_user', 'browser_size']),
    },
    mounted() {
    },
    methods: {
        // open_feed(){
        //     if(this.GL.ENV.is_afd_client){
        //         this.$mixin_router_push('/compose','','', '1');
        //         return false;
        //     }
        //     this.$mixin_show_modal_feed()
        // },
    }
};
</script>

<style lang="stylus" scoped>
.vm-feed-add-btn{
  border-radius: 1000px;
  border: 4px solid $purple-1;
  position:fixed;
  right:10px;
  z-index:2;
  bottom:60px;
  transform: translateY(-10px);

  @media (display-mode: fullscreen), (display-mode: standalone){
    bottom:60px + $afd-safe-area-bottom;
  }
  .inner-box {
      /* padding 10px */
      background: $purple;
      border-radius: 1000px;
      width: px2rem(48);
      height: px2rem(48);
      display: flex;
      align-items: center;
      justify-content: center;
  }

  .afd {
      font-size: 16px;
      color: $white;
  }

}
</style>
